module.exports = __webpack_public_path__ + "media/src/img/payment/googlePay-368efd8496ed0832ee8fd4c35f878b20.svg";